@if (loading | async) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="container mb-5">
        <div class="w-fit">
            <app-back-button routerLink="/price-rates" component="Price Rates"></app-back-button>
        </div>
        <div class="d-flex align-items-center mt-3">
            <div class="col-lg-12 col-12">
                <h1>Price Rate Entry</h1>
            </div>
        </div>
        <div class="row mt-4 mb-5">
            <form [formGroup]="form">
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Name<span class="required-input">*</span></mat-label>
                            <input type="text" matInput placeholder="Enter Price Rate Name" formControlName="name">
                            <mat-error *ngIf="form.controls['name'].errors?.['invalidPriceRateName']">* Price Rate Name is already in use</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Price For<span class="required-input">*</span></mat-label>
                            <mat-select formControlName="type_id">
                                <mat-option *ngFor="let priceType of priceTypesArray" [value]="priceType.id.toString()">
                                    {{ priceType.display_text }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Pricing Model<span class="required-input">*</span></mat-label>
                            <mat-select formControlName="pricing_model_id">
                                <mat-option *ngFor="let priceModel of pricingModels" [value]="priceModel.id.toString()">
                                    {{ priceModel.display_text }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Deductible<span class="required-input">*</span></mat-label>
                            <input type="number" matInput placeholder="Deductible" formControlName="deductible" min="0" onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                            <mat-label>Currency<span class="required-input">*</span></mat-label>
                            <mat-select formControlName="currency_id">
                                <mat-option *ngFor="let currency of currencies" [value]="currency.id.toString()">
                                    {{ currency.display_text }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline">
                            <textarea matInput placeholder="Description" formControlName="description"></textarea>
                        </mat-form-field>
                    </div>
                </div>
                <ng-container *ngIf="form.get('pricing_model_id')?.value === '1'">
                    <hr>
                    <div class="d-flex align-items-center my-4">
                        <div class="col-lg-12 col-12">
                            <h4>Tiered Night Pricing</h4>
                        </div>
                    </div>
                    <form [formGroup]="tieredNightForm">
                        <div formArrayName="night_ranges">
                            <div class="row" *ngFor="let nightRange of nightRanges().controls; let i=index" [formGroupName]="i">
                                <div class="col d-flex flex-column">
                                    <mat-form-field appearance="outline" hideRequiredMarker>
                                        <mat-label>From<span class="required-input">*</span></mat-label>
                                        <input type="number" matInput placeholder="From" formControlName="number_of_nights_from" [disabled]="tieredNightForm.get('number_of_nights_from')?.value === 1" min="0" oninput="this.value = this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                    </mat-form-field>
                                </div>
                                <div class="col d-flex flex-column">
                                    <mat-form-field appearance="outline" hideRequiredMarker>
                                        <mat-label>To<span class="required-input">*</span></mat-label>
                                        <input #nightsTo type="number" matInput placeholder="To" formControlName="number_of_nights_to" (input)="setTieredNightName(i, nightsTo.value)" min="0" oninput="this.value = this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                    </mat-form-field>
                                </div>
                                <div class="col d-flex flex-column">
                                    <mat-form-field appearance="outline" hideRequiredMarker>
                                        <mat-label>Name<span class="required-input">*</span></mat-label>
                                        <input type="text" matInput placeholder="Name" formControlName="name">
                                    </mat-form-field>
                                </div>
                                <div class="col d-flex flex-column">
                                    <mat-form-field appearance="outline" hideRequiredMarker>
                                        <mat-label>Price
                                            <ng-container *ngIf="existingPriceRate">({{priceRate.currency.code}})</ng-container>
                                            <span class="required-input">*</span>
                                        </mat-label>
                                        <input type="number" matInput placeholder="Price" formControlName="price" min="0" onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)">
                                    </mat-form-field>
                                </div>
                                <div class="col d-flex flex-column">
                                    <button mat-mini-fab class="remove-button" *ngIf="i != 0 && i === nightRanges().length - 1" (click)="removeNightRange(i)">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col d-flex flex-column">
                                <mat-form-field appearance="outline" hideRequiredMarker>
                                    <mat-label>Extra Night Price
                                        <ng-container *ngIf="existingPriceRate">({{priceRate.currency.code}})</ng-container>
                                        <span class="required-input">*</span></mat-label>
                                    <input type="text" matInput placeholder="Name" formControlName="extra_night_price" min="0" onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)">
                                </mat-form-field>
                            </div>
                            <div class="col d-flex flex-column"></div>
                            <div class="col-3 d-flex flex-column">
                                <button mat-raised-button class="action-button submit-price-rate-button" (click)="addNightRange()">Add New Tiered Night</button>
                            </div>
                            <div class="col d-flex flex-column"></div>
                        </div>
                    </form>
                </ng-container>
                <ng-container *ngIf="form.get('pricing_model_id')?.value === '2'">
                    <hr>
                    <div class="d-flex align-items-center my-4">
                        <div class="col-lg-12 col-12">
                            <h4>Per Night Pricing</h4>
                        </div>
                    </div>
                    <form [formGroup]="perNightForm">
                        <div class="row">
                            <div class="col d-flex flex-column">
                                <mat-form-field appearance="outline" hideRequiredMarker>
                                    <mat-label>Nightly Price 
                                        <ng-container *ngIf="existingPriceRate">({{priceRate.currency.code}})</ng-container>
                                        <span class="required-input">*</span>
                                    </mat-label>
                                    <input type="number" matInput placeholder="Nightly Price" formControlName="nightly_price" min="0" onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)">
                                </mat-form-field>
                            </div>
                            <div class="col d-flex flex-column"></div>
                            <div class="col d-flex flex-column"></div>
                        </div>
                    </form>
                </ng-container>
            </form>
        </div>
        <div class="mt-2 mb-2 d-flex justify-content-end">
            <button mat-raised-button class="finish-button" routerLink="/price-rates">
                <mat-icon>cancel</mat-icon>
                Cancel
            </button>
            <button mat-raised-button class="action-button submit-price-rate-button" [disabled]="!canCreatePriceRate() || priceRateNameExists || !this.form.get('name')?.value" (click)="submitPriceRate()">
                <mat-icon>check</mat-icon>
                Submit Price Rate
            </button>
        </div>
        <hr>
        <div *ngIf="!canCreatePriceRate()" class="mt-4">
            <mat-action-row class="mt-4 d-flex justify-content-end">
                <div class="d-flex justify-content-end align-items-center text-muted">
                    <span class="required-input">*</span>&nbsp;- Required fields before submitting Price Rate.
                </div>
            </mat-action-row>
        </div>
    </div>
}